/* eslint-disable no-undef */
// TODO: разобраться откуда берется ym и как это работает

import ls from 'local-storage';

import { API_ENDPOINT } from "../api/constants";


const CommonHelper = {

  getFilesCdnUrl(oldUrl) {
    if (oldUrl == undefined) {
      return undefined;
    }
    let s1 = oldUrl.replace('files.ape.ssstele.com', 'eroplay-files.b-cdn.net');
    s1 = s1.replace('files.cloud.eroplay.ai', 'eroplay-files.b-cdn.net');
    return s1;
  },

  getEroplayCdnUrl(path) {
    if (path == undefined) {
      return undefined;
    }

    const cdnUrl = import.meta.env.MODE === 'production' ? 'https://eroplay.b-cdn.net' : '';
    const fullPath = `${cdnUrl}${path}`;
    return fullPath;
  },

  getGAClientId() {
    const match = document.cookie.match(/_ga=(.+?);/);
    if (match) {
      return match[1]?.split('.')?.slice(-2)?.join('.');
    }
    return null;
  },


  yandexTrackEvent(eventName, params) {
    try {
      ym(97113455, 'reachGoal', eventName, params);
    } catch (exc) {

    }
  },

  yandexTrackFirstGameMessage(game) {
    if (game == undefined) {
      return;
    }
    const isAlreadyTracked = (ls(`isFirstGameMessageTracked_${game.id}`) == 'yes');
    if (isAlreadyTracked == true) {
      return;
    }
    ls(`isFirstGameMessageTracked_${game.id}`, 'yes');
    this.yandexTrackEvent('dialog-first-message', {
      name: game?.publicName
    });
  },

  // getTimestampFromDateString(s) {
  //     // new Date(Date.parse('2021-02-24T22:47:03.000Z'))
  //     if (s == undefined) {
  //         return +new Date();
  //     }
  //     if (s.indexOf('T') == -1) {
  //         s = `${s}T00:00:00.000Z`;
  //     }
  //     return Date.parse(`${s}.000Z`);
  // },

  getPatentAvatarUrl(patient) {
    const token = ls('token');
    if (patient == undefined || patient?.user?.avatar_id == undefined) {
      return undefined;
    }
    return `${API_ENDPOINT}/avatar/${patient?.uuid}/content?c_token=${token}&t=${0}&avatar_id=${patient?.user?.avatar_id}`;
  },

  getTimestampFromDateString(s) {
    // new Date(Date.parse('2021-02-24T22:47:03.000Z'))
    if (s == undefined) {
      return +new Date();
    }
    if (s.indexOf('T') == -1) {
      s = `${s}T00:00:00`;
    }

    function parseISOLocal(s) {
      var b = s.split(/\D/);
      return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);
    }

    return +parseISOLocal(s);
  },


  linkTo(patientUrl, inNewTab = false) {
    const url = window.location.origin + window.location.pathname + '#' + patientUrl;
    if (inNewTab == true) {
      window.open(url, '_blank').focus();
    } else {
      window.location.href = url;
    }
  },

  roundUp(num, precision) {
    precision = Math.pow(10, precision);
    return Math.ceil(num * precision) / precision;
  },

  downloadFile(filename, text) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },

  getPatientHeadingString(patient) {
    if (patient == undefined) {
      return '';
    }
    console.log('getPatientHeadingString: patient = ', patient);
    const { first_name, last_name, code } = patient;
    const fn = (first_name == undefined || first_name == '') ? 'Patient' : first_name;
    const ln = (last_name == undefined || last_name == '') ? (code == undefined || code == '' ? '' : code) : last_name;
    let name = `${fn} ${ln}`;
    if (code != undefined) {
      name = `${code} [${name}]`;
    }
    return name;
  },

  get60Colors() {
    return COLORS;
  }


};

const COLORS = [
  '#0408ff',
  '#ff0030',
  '#ff00db',
  '#ffc300',
  '#2bff00',
  '#0069ff',
  '#7800ff',
  '#2b00ff',
  '#ff2f00',

  '#00fcff',
  '#ff5f00',
  '#bf00ff',
  '#ff7600',
  '#00ff68',
  '#ffab00',
  '#fef100',
  '#00b5ff',
  '#02ff0c',
  '#d600ff',
  '#5a00ff',
  '#ff0076',
  '#009eff',
  '#00ff86',
  '#ffdb00',
  '#00ffb5',
  '#eeff00',
  '#ff9400',
  '#f400ff',
  '#ff0047',
  '#00ffe4',
  '#ff00c3',
  '#00ff51',
  '#0039ff',
  '#0051ff',
  '#ff005f',
  '#ff4700',
  '#14ff00',
  '#ff008e',
  '#ff1800',
  '#5bff00',
  '#0022ff',
  '#00ffcd',
  '#0080ff',
  '#00ff21',
  '#00e5ff',
  '#1300ff',
  '#fe00f1',
  '#00cdff',
  '#9000ff',
  '#a700ff',

  '#43ff00',
  '#ff00ac',
  '#00ff9d',
  '#72ff00',
  '#90ff00',
  '#4300ff'
];


export default CommonHelper;

